import gql from 'graphql-tag'

export const MUTATION_BLOCK_USERS_DISCOUTS = gql`
  mutation BlockUsersDiscounts($documents_no: [String!]!) {
    blockUsersDiscounts(documents_no: $documents_no) {
      users_already_blocked
      users_blocked_now
      invalid_users
    }
  }
`
